var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoBgPc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1920 1187.102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943,
    stopColor: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "silver"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -17.124,
    y1: 0.5,
    x2: -16.124,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.075,
    stopColor: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: -16.145,
    y1: 0.5,
    x2: -17.145,
    y2: 0.5,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8d8d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944,
    stopColor: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8d8d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "silver"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976,
    stopColor: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "silver"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: -16.624,
    y1: 1,
    x2: -16.624,
    y2: 0,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: -5.876,
    y1: 0.5,
    x2: -4.876,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.019,
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7b7b7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783,
    stopColor: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853,
    stopColor: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: -46.433,
    y1: 0.5,
    x2: -47.433,
    y2: 0.5,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: -29.701,
    y1: 0.5,
    x2: -28.701,
    y2: 0.5,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: -18.277,
    y1: 0.5,
    x2: -17.277,
    y2: 0.5,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: -474.693,
    y1: 0.5,
    x2: -473.693,
    y2: 0.5,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: -36.933,
    y1: 0.5,
    x2: -35.933,
    y2: 0.5,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: -84.822,
    y1: 0.5,
    x2: -83.822,
    y2: 0.5,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: -47.798,
    y1: 0.5,
    x2: -46.798,
    y2: 0.5,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: -330.132,
    y1: 0.5,
    x2: -329.132,
    y2: 0.5,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.005,
    y1: 0.5,
    x2: 0.995,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.024,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#dedede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: -455.883,
    x2: -454.883,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: -455.768,
    x2: -454.768,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: -495.907,
    x2: -494.907,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: -444.991,
    x2: -443.991,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: -442.16,
    x2: -441.16,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 5.247,
    x2: 6.247,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 5.247,
    x2: 6.247,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009,
    stopColor: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.044,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#c2c2c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7b7b7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.606,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: -280.71,
    y1: -0.75,
    x2: -280.71,
    y2: 0.25,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 20.424,
    y1: -0.75,
    x2: 20.424,
    y2: 0.25,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: -6.171,
    x2: -5.171,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: -66.966,
    y1: 0.5,
    x2: -65.966,
    y2: 0.5,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: -23.024,
    x2: -22.024,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.059,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.937,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8d8d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8d8d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "play_button_color1",
    cx: 0.5,
    cy: 0.5,
    r: 0.654,
    gradientTransform: "matrix(.642 0 0 1 .179 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    stopColor: "#f8f6fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#e5e0fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#c7bcf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9d8af1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#775cec"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "play_button_color2",
    cx: 0.5,
    cy: 0.5,
    r: 0.558,
    gradientTransform: "matrix(.819 0 0 1 .091 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a195ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#a89dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#bbb3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#dbd7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 10",
    transform: "translate(2.367)",
    fill: "none",
    d: "M0 0h1919v385.849H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 11",
    transform: "translate(2.413 761.92)",
    fill: "none",
    d: "M0 0h1919v425.182H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24",
    d: "m675.955 79.518 40.822 27.528-160.822 108.123-527.542-85.453v-50.2Z",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28",
    d: "M748.551 118.357h425.972L1256.8 221.4H666.271Z",
    fill: "url(#b)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "S"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 78",
    d: "m1246.871 79.518-40.822 27.528 160.821 108.123 527.542-85.453v-50.2Z",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#k)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 0.5,
    cy: 0.5,
    r: 1.154,
    gradientTransform: "matrix(.322 0 0 1 .339 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a195ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#9b8cfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#8a76f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#775cec"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "N",
    cx: 0.5,
    cy: 0.5,
    r: 0.654,
    gradientTransform: "matrix(.642 0 0 1 .179 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#a195ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614,
    stopColor: "#9b8cfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812,
    stopColor: "#8a76f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#775cec"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "R",
    r: 0.558,
    gradientTransform: "matrix(.819 0 0 1 .091 0)",
    xlinkHref: "#j"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 314",
    transform: "translate(-1.413)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 35",
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20",
    d: "M2334.132-97.154C2334.132 96.729 1718.912 253.9 960 253.9S-414.132 96.729-414.132-97.154",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#n)"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37",
    clipPath: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21",
    d: "M-99.486 1187.1c0-172.206 474.383-311.807 1059.564-311.807S2019.641 1014.9 2019.641 1187.1",
    stroke: "#a5a5a5",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#d)"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 12",
    transform: "translate(518.091 289.028)",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    fill: "url(#h)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 887,
    height: 504.654,
    rx: 24.405,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 886,
    height: 503.654,
    rx: 23.905,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22",
    d: "m675.955 79.518 40.822 27.528-160.822 108.123-527.542-85.453v-50.2Z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 39",
    clipPath: "url(#p)",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 1",
    transform: "translate(102.138 -308.374)",
    fill: "url(#h)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 860.61,
    cy: 232.128,
    rx: 860.61,
    ry: 232.128,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 860.61,
    cy: 232.128,
    rx: 860.36,
    ry: 231.878,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 23",
    d: "m702.382 97.339-154.076 93.695 7.649 24.135 160.821-108.123Z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1",
    transform: "translate(28.413 97.339)",
    fill: "url(#l)",
    d: "m0 0 519.893 93.694"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25",
    d: "m675.955 79.518 40.822 27.528-160.822 108.123-527.542-85.453v-50.2Z",
    fill: "none",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26",
    d: "M748.551 118.357h425.972L1256.8 221.4H666.271Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 41",
    clipPath: "url(#q)",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27",
    d: "M748.551 118.357h425.972L1256.8 221.4H666.271Z",
    fill: "url(#r)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 2",
    cx: 860.61,
    cy: 232.128,
    rx: 860.61,
    ry: 232.128,
    transform: "translate(102.138 -308.374)",
    fill: "url(#s)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 2",
    fill: "none",
    d: "M1240.449 200.922H681.925"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 30",
    d: "m676.22 79.518 40.822 27.528L556.22 215.169 28.678 129.716v-50.2Z",
    fill: "none",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 44"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31",
    d: "m259.149 1080-167.825-.163a62.708 62.708 0 0 1-62.646-62.707v-57.742L259.149 980.2Z",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 32",
    d: "M607.712 882.22a86.732 86.732 0 0 1-54.612 80.564L259.149 1080v-99.8Z",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#t)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 33",
    d: "m546.956 845.23 60.756 36.991L259.149 980.2 28.678 959.388V925.5Z",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 3",
    cx: 11.699,
    cy: 11.699,
    r: 11.699,
    transform: "translate(44.719 982.817)",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34",
    d: "m263.95 900.775 69.732 46.725-75.589 21.213-218.076-19.685v-13.8Z",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35",
    d: "m544.592 857.065 34.956 21.282-76.374 21.591-43.648-29.249Z",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 36",
    d: "m470.2 873.03 73.565-11.782 25.863 15.746-65.768 18.592Z",
    fill: "#775cec",
    stroke: "#666",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 37",
    d: "m448.5 872.385 45.118 30.234-150.386 42.2-68.259-45.739Z",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 38",
    d: "m285.729 901.473 161.842-24.9 36.616 24.536-140.257 39.364Z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 39",
    d: "M44.017 945.372v-6.717l219-33.689L324.247 946l-66.528 18.67Z",
    fill: "#a296ff"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40",
    d: "M270.963 1015.991v46.241l32.246-14.535Z",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#g)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41",
    d: "m1663.678 1080 167.824-.163a62.708 62.708 0 0 0 62.646-62.707v-57.742l-230.47 20.812Z",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#u)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 42",
    d: "M1315.114 882.22a86.732 86.732 0 0 0 54.607 80.564L1663.678 1080v-99.8Z",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#v)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 43",
    d: "m1375.87 845.23-60.756 36.991 348.563 97.979 230.47-20.807V925.5Z",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#w)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 4",
    cx: 11.699,
    cy: 11.699,
    r: 11.699,
    transform: "translate(1854.709 982.817)",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#x)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 44",
    d: "m1658.876 900.775-69.731 46.725 75.589 21.213 218.075-19.688v-13.8Z",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#y)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45",
    d: "m1378.234 857.065-34.956 21.282 76.374 21.591 43.648-29.249Z",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#z)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46",
    d: "m1452.621 873.03-73.565-11.782-25.863 15.746 65.768 18.592Z",
    fill: "#775cec",
    stroke: "#666",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47",
    d: "m1474.323 872.385-45.118 30.234 150.386 42.2 68.262-45.742Z",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 48",
    d: "m1637.1 901.473-161.842-24.9-36.616 24.536 140.257 39.36Z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 49",
    d: "M1878.809 945.372v-6.717l-219-33.689-61.23 41.034 66.528 18.67Z",
    fill: "#a296ff"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 50",
    d: "M1651.864 1015.991v46.241l-32.246-14.535Z",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#B)"
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 13",
    width: 400.371,
    height: 12.909,
    rx: 6.454,
    transform: "rotate(172.013 208.217 431.685)",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 53"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 53",
    d: "M1276.236 1080H647.5l-103.27 84h835.27Z",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#J)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 52"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 14",
    fill: "#d8d8d8",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "M624.163 1069.85h675.476v34.772H624.163z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 54",
    d: "M1320.9 1016.138a100.286 100.286 0 0 1-37.779 78.424l-26.275 20.943H665.982l-26.275-20.943a100.287 100.287 0 0 1-37.78-78.424l64.055 27.532h590.862Z",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#K)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 15",
    transform: "translate(665.982 1043.67)",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#d)",
    d: "M0 0h590.862v71.837H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 55",
    d: "M1278.495 946.293a294.407 294.407 0 0 0-230.064-110.705h-174.3a294.407 294.407 0 0 0-230.066 110.705h634.43Z",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#L)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 56",
    d: "M1230.8 898.392H692.029a43.821 43.821 0 0 0-38.494 22.88l-51.608 94.866 64.055 27.532h590.862l64.054-27.532-51.607-94.866a43.823 43.823 0 0 0-38.491-22.88Z",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#L)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57",
    d: "m850.766 926.068-21.823 90.071h20.225l17.386-90.071Z",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#M)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58",
    d: "m875.777 926.068-16.262 90.071h20.225l12.6-90.071Z",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#M)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59",
    d: "m831.511 847.853-21.823 41.241h20.225l17.387-41.241Z",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#M)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 60",
    d: "m856.522 847.853-16.262 41.24h20.225l12.6-41.241Z",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#M)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 17",
    cx: 12.569,
    cy: 12.569,
    r: 12.569,
    transform: "translate(888.168 863.956)",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#M)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 61",
    d: "m959.978 866.451-11.558-9.3-11.558-9.3h46.232l-11.558 9.3Z",
    fill: "#775cec"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 62",
    d: "m959.978 889.093 11.558-9.3 11.558-9.3h-46.232l11.558 9.3Z",
    fill: "#775cec"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 63",
    d: "M1015.348 926.068h-110.74l-12.27 90.071h135.279Z",
    stroke: "#666",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "pc_next_video_button",
    "data-name": "Group 49",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 18",
    cx: 74.265,
    cy: 45.035,
    rx: 74.265,
    ry: 45.035,
    transform: "translate(1098.396 926.068)",
    stroke: "#666",
    strokeWidth: 3,
    fill: "url(#O)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "next_video_button_bg",
    "data-name": "Path 65",
    d: "M1172.661 1010.048c-36.955 0-68.176-17.835-68.176-38.945s31.221-38.945 68.176-38.945 68.174 17.835 68.174 38.945-31.22 38.945-68.174 38.945Z",
    stroke: "#bebebe",
    fill: "url(#L)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 72",
    d: "m1152.632 948.91 10.021 38.614 47.255-22.98Z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 66",
    d: "m1069.191 926.068 21.823 90.071h-20.225l-17.389-90.071Z",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#M)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 67",
    d: "m1044.18 926.068 16.262 90.071h-20.225l-12.6-90.071Z",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#M)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68",
    d: "m1088.446 847.853 21.823 41.241h-20.225l-17.386-41.241Z",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#M)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 69",
    d: "m1063.435 847.853 16.262 41.241h-20.225l-12.6-41.241Z",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#M)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 19",
    cx: 12.569,
    cy: 12.569,
    r: 12.569,
    transform: "translate(1006.652 863.956)",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#M)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 50",
    stroke: "#666",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 70",
    d: "m1107.24 865.529 13.917 23.564h20.872Z",
    fill: "url(#P)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 71",
    d: "m812.635 865.529-13.917 23.564h-20.872Z",
    fill: "url(#Q)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "pc_prev_video_button",
    "data-name": "Group 51",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 20",
    cx: 74.265,
    cy: 45.035,
    rx: 74.265,
    ry: 45.035,
    transform: "translate(673.032 926.068)",
    stroke: "#666",
    strokeWidth: 3,
    fill: "url(#O)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prev_video_button_bg",
    "data-name": "Path 73",
    d: "M747.3 1010.048c36.954 0 68.175-17.835 68.175-38.945s-31.225-38.945-68.175-38.945-68.174 17.835-68.174 38.945 31.215 38.945 68.174 38.945Z",
    stroke: "#bebebe",
    fill: "url(#L)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 74",
    d: "M767.324 948.91 757.3 987.524l-47.255-22.98Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "pc_play_button"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pc_play_button_bg",
    "data-name": "Path 64",
    d: "m899.315 1010.048 10.61-77.889h100.105l10.61 77.889Z",
    fill: "url(#N)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "pc_play_button_center",
    "data-name": "Ellipse 21",
    cx: 31.847,
    cy: 26.075,
    rx: 31.847,
    ry: 26.075,
    transform: "translate(928.091 944.108)",
    fill: "url(#R)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Play Now",
    transform: "translate(630 103)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8",
    d: "M290.785 860.075h7.515v1.879h-5.637v1.879h5.637v1.879h-5.637v3.732h-1.879Zm7.516 1.879h1.879v1.879h-1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9",
    d: "M301.767 860.075h1.878v7.516h7.516v1.853h-9.394Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10",
    d: "M312.748 861.954h1.879v1.879h5.637v-1.879h1.878v7.49h-1.878v-3.732h-5.637v3.732h-1.879Zm1.879-1.879h5.637v1.879h-5.637Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11",
    d: "M323.729 860.075h1.879v1.879h-1.879Zm1.879 1.879h1.879v1.879h-1.879Zm1.879 1.879h1.879v5.611h-1.879Zm1.879-1.879h1.879v1.879h-1.879Zm1.879-1.879h1.879v1.879h-1.879Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12",
    d: "M339.154 860.075h1.879v1.879h1.879v1.879h-1.879v5.611h-1.879Zm3.758 3.758h1.879v1.879h-1.879Zm3.758-3.758h1.879v9.369h-1.879v-1.853h-1.879v-1.879h1.879Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13",
    d: "M350.136 861.954h1.879v5.637h-1.879Zm1.879-1.879h5.636v1.879h-5.636Zm0 7.516h5.636v1.853h-5.636Zm5.636-5.637h1.879v5.637h-1.879Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14",
    d: "M361.117 860.075H363v5.637h1.879v1.879H363v1.853h-1.879Zm3.758 3.758h1.879v1.879h-1.879Zm3.758-3.758h1.879v9.369h-1.879v-1.853h-1.879v-1.879h1.879Z"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 75",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M748.551 118.357h425.972L1256.8 221.4H666.271Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.792 118.857 667.31 220.903h588.454l-81.481-102.046H748.792m-.24-.5h425.971l82.28 103.046H666.271l82.28-103.046Z",
    fill: "#bebebe"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 56"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 76",
    d: "m1246.871 79.518-40.822 27.528 160.821 108.123 527.542-85.453v-50.2Z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54",
    clipPath: "url(#S)",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 22",
    transform: "translate(99.467 -308.374)",
    fill: "url(#T)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 860.61,
    cy: 232.128,
    rx: 860.61,
    ry: 232.128,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 860.61,
    cy: 232.128,
    rx: 860.36,
    ry: 231.878,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 77",
    d: "m1220.444 97.339 154.076 93.694-7.649 24.135-160.821-108.122Z",
    fill: "url(#U)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3",
    transform: "translate(1374.52 97.339)",
    fill: "url(#V)",
    d: "M519.893 0 0 93.694"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 79",
    d: "m1246.871 79.518-40.822 27.528 160.821 108.123 527.542-85.453v-50.2Z",
    fill: "none",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 80",
    d: "m1246.606 79.518-40.822 27.528 160.821 108.123 527.542-85.453v-50.2Z",
    fill: "none",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 16",
    fill: "none",
    d: "M1.413 0h1920v1080h-1920z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17",
    fill: "none",
    d: "M1894.413 27v1160.102h-1866V27z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 81",
    d: "M28.165 13.376v13.376H14.789",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 82",
    d: "M1908.165 26.644h-13.376V13.268",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "pc_screen1",
    "data-name": "Path 83",
    d: "M47.39 838.81c-4.591 0-9.2-1.494-11.81-12.333-2.227-9.245-2.226-22.138-2.224-35.789V276.257c0-13.152 0-26.75 2.05-36.5 2.428-11.55 6.565-13.107 10.291-13.107a16.756 16.756 0 0 1 4.3.64l.577.118 422.01 59.606c18.046 4.258 18.768 17.306 18.768 48.882V740.97c0 31.491-.754 45.594-18.59 48.855l-422.25 48.726a20.428 20.428 0 0 1-3.122.259Z",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pc_screen3",
    "data-name": "Path 84",
    d: "M1875.113 838.81a20.429 20.429 0 0 1-3.122-.259l-422.254-48.726c-17.836-3.261-18.589-17.364-18.589-48.855V335.892c0-31.576.722-44.624 18.768-48.882l422.009-59.61.578-.118a16.743 16.743 0 0 1 4.3-.64c3.726 0 7.863 1.557 10.291 13.107 2.05 9.754 2.05 23.352 2.05 36.5v514.439c0 13.65 0 26.544-2.224 35.789-2.606 10.839-7.22 12.333-11.807 12.333Z",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 85",
    d: "M47.39 838.81a20.408 20.408 0 0 0 3.122-.259l422.255-48.726c17.835-3.261 18.589-17.364 18.589-48.855V335.892c0-31.576-.722-44.624-18.768-48.882L50.578 227.4l-.578-.114a16.756 16.756 0 0 0-4.3-.64c-3.726 0-7.863 1.557-10.291 13.107-2.05 9.754-2.05 23.352-2.05 36.5v514.435c0 13.65 0 26.544 2.224 35.789C38.19 837.316 42.8 838.81 47.39 838.81Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "pc_screen2",
    "data-name": "Rectangle 18",
    width: 494.168,
    height: 877,
    rx: 19.405,
    transform: "rotate(90 552.91 847.181)",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 88",
    d: "M1174.523 96.25H748.551l-31.51-16.732h488.743Z",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#W)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4",
    d: "M35.1 1164c-3.7 0-6.69-2.6-6.69-5.823 0-3.258 2.987-5.857 6.69-5.857a6.734 6.734 0 0 1 6.412 4.02h172.394c28.991 0 58.261-7 83.349-17.988 17.8-7.763 24.849-43.428 63.836-42.838-12.106 17.537-34.606 34.139-61.964 46.131-25.646 11.195-55.593 18.335-85.221 18.335H41.515A6.734 6.734 0 0 1 35.1 1164Z",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#X)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5",
    d: "M1887.475 1164a6.731 6.731 0 0 1-6.411-4.02h-172.392c-29.628 0-59.575-7.14-85.221-18.335-27.358-11.992-49.858-28.594-61.964-46.131 38.987-.59 46.035 35.075 63.836 42.838 25.088 10.987 54.358 17.988 83.349 17.988h172.392a6.732 6.732 0 0 1 6.411-4.02c3.7 0 6.69 2.6 6.69 5.857 0 3.224-2.987 5.823-6.69 5.823Z",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#Y)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoBgPc);
export default __webpack_public_path__ + "static/media/video_bg_pc.575f9b5b.svg";
export { ForwardRef as ReactComponent };